import { css } from '@inter-ikea-kompis/web-component';
export default class MiniSurveyCardStyle {
    /**
     * Returns styles.
     *
     * @param options ...
     * @param options.theme ...
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			:host {
				display: block;
				width: 100%;
			}

			.container {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}

			.headerContainer {
				display: flex;
				flex-direction: row;
				flex: 1;
				justify-content: space-between;
				outline: none;
			}

			.headerContainer skapa-icon-button {
				pointer-events: inherit;
				align-self: flex-start;
				margin-top: -${8 / 16}rem;
				margin-right: -${8 / 16}rem;
			}

			.headerContainer kompis-text {
				padding-top: ${spacing.space50 / 16}rem;
			}

			.question {
				display: flex;
				padding-top: ${spacing.space50 / 16}rem;
			}

			.binaryChoiceContainer {
				display: grid;
				grid-template-columns: 1fr 1fr;
				grid-gap: 1rem;
			}

			kompis-icon-pill-group {
				display: flex;
				justify-content: space-between;
			}

			.binaryChoiceContainer,
			kompis-icon-pill-group {
				padding-top: ${spacing.space100 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=MiniSurveyCardStyle.js.map